import { memo } from 'react';
import styled, { css } from 'styled-components';
import { colors, spacing } from '@izettle/otto';
import { Icon } from '../icon/index.js';
import { SemanticState } from '../../enumerations/semantic-state.js';

const mixinInputControlLeftPalette = css`
  color: ${_ref => {
  let {
    isDisabled
  } = _ref;
  if (isDisabled) {
    return colors.icon.disabled;
  }
}};
`;
const mixinInputControlRightPalette = css`
  color: ${_ref2 => {
  let {
    semanticState,
    isFocused,
    isDisabled
  } = _ref2;
  if (isDisabled) {
    return colors.icon.disabled;
  }
  if (isFocused) {
    return colors.icon.action;
  }
  return {
    [SemanticState.Warning]: colors.icon.warning.small,
    [SemanticState.Error]: colors.icon.error.small,
    [SemanticState.Success]: colors.icon.success.small,
    [SemanticState.Default]: colors.icon.default
  }[semanticState ?? SemanticState.Default];
}};
`;
const InputIconGeneric = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "styles__InputIconGeneric",
  componentId: "zettle__sc-kj69sn-0"
})(["font-size:24px;min-height:100%;display:flex;align-items:center;transition:color 0.1s cubic-bezier(0.25,0.1,0.25,1);outline:none;"]);
const InputIconLeftMemoized = /*#__PURE__*/memo(styled(InputIconGeneric).withConfig({
  displayName: "styles__InputIconLeftMemoized",
  componentId: "zettle__sc-kj69sn-1"
})(["color:", ";padding-left:", ";", ""], colors.icon.default, spacing.small, mixinInputControlLeftPalette));
const InputIconMemoized = /*#__PURE__*/memo(styled(InputIconGeneric).withConfig({
  displayName: "styles__InputIconMemoized",
  componentId: "zettle__sc-kj69sn-2"
})(["padding-right:", ";", ""], spacing.small, mixinInputControlRightPalette));

export { InputIconLeftMemoized, InputIconMemoized };
//# sourceMappingURL=styles.js.map
